<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
    </transition>
      <div style="content: ' '; clear: both;"></div>
      <div class="footer-MrHuang">
          <p style="margin: 0">@ Never underestimate your power to change you ------ Mr.Huang</p>
      </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>
<style>
    .footer-MrHuang {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 70px;
        color: #BABABA;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue